module.exports = __webpack_public_path__ + "static/media/minilogo-versar.91d9cd31.svg";